import React from 'react'
import clsx from 'clsx'
import { Typography } from '@material-ui/core'
import useTakeBackStyle from '../../components/TakeBack/TakeBack.style'
import CMSText from '../Global/CMSText'

type Tprops = {
  children: JSX.Element[] | JSX.Element
  activeStep: number
  t: any
  data: any
  hideStep2?: boolean
  additionalEditParcelNumberStep?: boolean
}

const TakeBackBox = ({
  children,
  activeStep,
  t,
  data,
  hideStep2,
  additionalEditParcelNumberStep,
}: Tprops) => {
  const classes = useTakeBackStyle()

  const array = additionalEditParcelNumberStep ? [0, 1, 2, 3] : [0, 1, 2]

  return (
    <Typography
      variant="body1"
      component="div"
      className={classes.takeBackBoxContainer}
    >
      <ol
        className={clsx('takeBack__nav', classes.takebackNav)}
        id="takeBack__nav"
      >
        {array.map((index) => {
          if (hideStep2) {
            if (
              (index === 1 && !additionalEditParcelNumberStep) ||
              (index === 2 && additionalEditParcelNumberStep)
            ) {
              return null
            }
          }
          const isActive = index === activeStep
          const humanIndex = index + 1
          let defaultText = `texts:takeBack:step_${humanIndex}`
          let cmsText = `take_back_title_step_${humanIndex}`
          let renderedIndex = humanIndex

          if (additionalEditParcelNumberStep) {
            if (index === 1) {
              defaultText = 'texts:takeBack:step_edit_parcel_number'
              cmsText = 'take_back_title_step_edit_parcel_number'

              renderedIndex = 2
            }
            if (index > 1) {
              defaultText = `texts:takeBack:step_${humanIndex - 1}`
              cmsText = `take_back_title_step_${humanIndex - 1}`

              renderedIndex = humanIndex - 1
            }
          }

          return (
            <>
              {index > 0 && (
                <li
                  aria-hidden="true"
                  className={clsx(
                    classes.separator,
                    'takeBack__nav__separator'
                  )}
                >
                  |
                </li>
              )}
              <li
                key={index}
                className={clsx(
                  'takeBack__nav__item',
                  isActive && [classes.active, 'takeBack__nav__item--active'],
                  classes.listItem
                )}
              >
                <b
                  className={clsx(
                    'takeBack__nav__step',
                    classes.stepNumber,
                    isActive && 'takeBack__nav__step--active'
                  )}
                >
                  {renderedIndex}
                </b>
                <span className={clsx('takeBack__nav__label')}>
                  <CMSText
                    asText
                    defaultText={t(defaultText)}
                    data={data && data[cmsText]}
                  />
                </span>
              </li>
            </>
          )
        })}
      </ol>
      <div className={clsx('takeBack-box__content')}>{children}</div>
    </Typography>
  )
}

export default TakeBackBox
